<template>
	<div class="js-comments">
		<div class="comments__filters fadeIn">
			<form action="/">
				<div class="form-group">
					<span class="type-label display-inline-block no-bottom-margin padding-right-m">Filter By: </span>
					<div class="form-group form-group--community form-group--inline">
						<label for="experience-type" class="visually-hidden">Experience Type</label>
						<select id="experience-type" @change="updateActiveExperiences">
							<option value="all" selected>Experience Type</option>
							<option v-for="experience in experiences" :key="experience" :value="experience">
								{{ capitalize(experience) }} it
							</option>
						</select>
					</div>
					<div class="form-group form-group--community form-group--inline">
						<label for="connection-to-theatre" class="visually-hidden">Connection to Theatre</label>
						<select id="connection-to-theatre" @change="updateActiveConnections">
							<option value="all" selected>Connection to Theatre</option>
							<option v-for="connection in connections" :key="connection" :value="connection">
								{{ capitalize(connection) }}
							</option>
						</select>
					</div>
				</div>
				<!-- <div class="form-group">
					<span class="type-label display-inline-block">Common Descriptions:</span>
					<ul class="comments__tags-list">
						<li v-for="tag in tags">
							<input type="checkbox" class="input-checkbox input-checkbox--pill" :id="tag" :key="tag" name="tags" v-model="activeTags" :value="tag">
							<label :for="tag" class="pill" v-text="tag"></label>
						</li>
					</ul>
				</div> -->
			</form>
		</div>
		<div class="comments__comment-container fadeIn" v-if="filteredComments.length">
			<comment v-for="comment in (showAll ? authComments : authComments.slice(0, 6))"
				:key="comment.id"
				:comment="comment"
			/>
			<div class="comments__footer" v-if="showAll">
				<a href="#" class="type-link type-link--arrow type-small" @click.prevent="showAllComments">See all {{ comments.length - 1 }} Community Experiences</a>
			</div>
		</div>
		<div class="comments__comment-container fadeIn" v-else>
			<div class="comments__text fadeIn">
				<h4 class="type-h4">No results match your selection</h4>
			</div>
		</div>
	</div>
</template>

<script>
import Comment from './Comment.vue';
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'CommentsList',
	components: {
		Comment,
	},
	props: ['comments'],
	data() {
		return {
			connections: ['Theatre Enthusiast', 'K-12 Teacher', 'Actor', 'Director'],
			experiences: ['saw', 'read', 'performed', 'worked', 'produced'],
			tags: [],
		};
	},
	mounted() {
		this.setCommentConfig();
	},
	methods: {
		setCommentConfig() {

			[].forEach.call(this.comments, (comment) => {
				comment.Tags.forEach(tag => {
					if(!this.tags.includes(tag)){
						this.tags.push(tag);
					}
				});
			});
		},
		capitalize(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		showAllComments() {
			this.$store.commit('showAllComments');
		},
		updateActiveConnections($event) {
			this.$store.commit('updateConnections', $event.target.value);
		},
		updateActiveExperiences($event) {
			this.$store.commit('updateExperiences', $event.target.value);
		},
	},
	computed: {
		...mapState({
			showAll: state => state.commentsModule.showAll,
			activeConnections: state => state.commentsModule.activeConnections,
			activeExperiences: state => state.commentsModule.activeExperiences,
			activeTags: state => state.commentsModule.activeTags,
			isLoggedIn: state => state.AuthStore.isLoggedIn,
			customer: state => state.AuthStore.customer,
		}),

		...mapGetters([
			'filteredComments',
		]),

		authComments() {
			if( !this.isLoggedIn ) {
				return this.filteredComments.filter(item => item.Pending == false);
			}

			// logged in, so we show the pending items that match the current customer
			return this.filteredComments
				.filter(item => item.Pending || item.CustomerId != this.customer.Id);
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CommentsList.vue